
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(033|746|780)|5(34[15]|709|837|894)|6([56]08|039|112|155|333|497|674)|1(080|477|534|566|692|74|851|961)|30[02]1|2461|7565|8492|9183|9502)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
